import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";

// Images
// import avatar1 from "assets/images/users/avatar-1.jpg";
// import avatar2 from "assets/images/users/avatar-2.jpg";
// import avatar3 from "assets/images/users/avatar-3.jpg";
// import avatar4 from "assets/images/users/avatar-4.jpg";
// import avatar5 from "assets/images/users/avatar-5.jpg";
import backgroundImage from "assets/login_page_background5.jpg";
import withRouter from "Common/withRouter";

const ParticlesAuth = ({ children }: any) => {
  return (
    <React.Fragment>
      <div className="auth-page-wrapper py-5 position-relative d-flex align-items-center justify-content-center min-vh-100">
        <Container>
          <Row className="justify-content-center">
            <Col lg={11}>
              <Card className="mb-0">
                <Row className="g-0 align-items-center">
                  {/* Left side */}
                  <Col xxl={5} className="d-none d-xxl-block">
                    <Card 
                      className="auth-card h-100 border-0 shadow-none mb-0 position-relative overflow-hidden"
                      style={{
                        background: 'linear-gradient(135deg, #2d3748 0%, #4a5568 50%, #718096 100%)',
                        borderRadius: '0.5rem 0 0 0.5rem',
                        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)'
                      }}
                    >
                      {/* Animated background elements */}
                      <div 
                        className="position-absolute top-0 start-0 w-80 h-80"
                        style={{
                          background: `url(${backgroundImage})`,
                          backgroundSize: 'contain',
                          backgroundPosition: 'center',
                          opacity: 0.15,
                          filter: 'blur(1px)',
                          backgroundRepeat: 'no-repeat'
                        }}
                      />
                      
                      {/* Floating particles effect */}
                      <div className="position-absolute top-0 start-0 w-100 h-100">
                        <div 
                          className="position-absolute rounded-circle"
                          style={{
                            width: '6px',
                            height: '6px',
                            background: 'rgba(255,255,255,0.15)',
                            top: '20%',
                            left: '20%',
                            animation: 'float 6s ease-in-out infinite'
                          }}
                        />
                        <div 
                          className="position-absolute rounded-circle"
                          style={{
                            width: '8px',
                            height: '8px',
                            background: 'rgba(255,255,255,0.1)',
                            top: '60%',
                            right: '25%',
                            animation: 'float 8s ease-in-out infinite reverse'
                          }}
                        />
                        <div 
                          className="position-absolute rounded-circle"
                          style={{
                            width: '4px',
                            height: '4px',
                            background: 'rgba(255,255,255,0.2)',
                            bottom: '30%',
                            left: '15%',
                            animation: 'float 7s ease-in-out infinite'
                          }}
                        />
                      </div>

                      <Card.Body className="py-5 d-flex justify-content-between flex-column position-relative">
                        {/* Top section with logo/brand */}
                        <div className="text-center mb-4">
                          <div 
                            className="mx-auto mb-4 d-flex align-items-center justify-content-center position-relative"
                            style={{
                              width: '80px',
                              height: '80px',
                              background: 'rgba(255,255,255,0.15)',
                              borderRadius: '20px',
                              backdropFilter: 'blur(10px)',
                              border: '1px solid rgba(255,255,255,0.2)',
                              boxShadow: '0 4px 16px rgba(0,0,0,0.1)'
                            }}
                          >
                            <i className="ph ph-buildings text-white" style={{ fontSize: '2rem' }}></i>
                          </div>
                          <h2 
                            className="text-white mb-3 fw-bold"
                            style={{
                              fontSize: '1.75rem',
                              letterSpacing: '-0.5px'
                            }}
                          >
                            ABGB Staff Portal
                          </h2>
                          <p 
                            className="text-white opacity-90 mb-0"
                            style={{
                              fontSize: '1rem',
                              fontWeight: 400,
                              lineHeight: 1.5
                            }}
                          >
                            Internal Quotation Management System
                          </p>
                        </div>

                        {/* Main content area */}
                        <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                          <div className="text-center">
                            <div 
                              className="mx-auto mb-4 p-4"
                              style={{
                                background: 'rgba(255,255,255,0.1)',
                                borderRadius: '20px',
                                backdropFilter: 'blur(15px)',
                                border: '1px solid rgba(255,255,255,0.15)',
                                maxWidth: '320px'
                              }}
                            >
                              <div className="mb-3">
                                <i className="ph ph-shield-check text-white" style={{ fontSize: '2.5rem' }}></i>
                              </div>
                              <h4 
                                className="text-white mb-3 fw-bold"
                                style={{
                                  fontSize: '1.25rem'
                                }}
                              >
                                Staff Access Portal 🔐
                              </h4>
                              <p 
                                className="text-white opacity-90 mb-0"
                                style={{
                                  fontSize: '0.95rem',
                                  lineHeight: 1.6
                                }}
                              >
                                Secure access to internal quotation management tools for authorized staff and administrators
                              </p>
                            </div>

                            {/* Feature highlights */}
                            <div className="row g-3 mt-4">
                              <div className="col-6">
                                <div 
                                  className="p-3 text-center"
                                  style={{
                                    background: 'rgba(255,255,255,0.08)',
                                    borderRadius: '12px',
                                    border: '1px solid rgba(255,255,255,0.1)'
                                  }}
                                >
                                  <i className="ph ph-file-text text-white mb-2 d-block" style={{ fontSize: '1.5rem' }}></i>
                                  <small className="text-white opacity-90">Quotation Management</small>
                                </div>
                              </div>
                              <div className="col-6">
                                <div 
                                  className="p-3 text-center"
                                  style={{
                                    background: 'rgba(255,255,255,0.08)',
                                    borderRadius: '12px',
                                    border: '1px solid rgba(255,255,255,0.1)'
                                  }}
                                >
                                  <i className="ph ph-chart-bar text-white mb-2 d-block" style={{ fontSize: '1.5rem' }}></i>
                                  <small className="text-white opacity-90">Staff Analytics</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Bottom section */}
                        <div className="text-center">
                          <div 
                            className="d-flex align-items-center justify-content-center gap-3 mb-3"
                            style={{ fontSize: '0.9rem' }}
                          >
                            <span className="text-white opacity-75">Internal Staff Portal</span>
                            <div className="d-flex gap-1 align-items-center justify-content-center">
                              <i className="ph ph-shield-check text-success" style={{ fontSize: '1rem' }}></i>
                              <span className="text-white opacity-75 ms-1">Secure Access</span>
                            </div>
                          </div>
                          <p 
                            className="text-white opacity-60 mb-0"
                            style={{ fontSize: '0.85rem' }}
                          >
                            &copy; {new Date().getFullYear()} ABGB. All rights reserved.
                          </p>
                        </div>
                      </Card.Body>

                    </Card>
                  </Col>

                  {/* Right side - login form */}
                  <Col
                    xs={12}
                    xxl={7}
                    className="d-flex justify-content-center"
                  >
                    {children}
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ParticlesAuth);
